import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

export const RadioGroups = (props) => {
  const { description = "", label = "", options = [], ...restProps } = props;
  return (
    <FormControl>
      {label ? <FormLabel>{label}</FormLabel> : null}
      <RadioGroup
        {...restProps}
        style={{ display: "flex", flexDirection: "row" }}
      >
        {options.map(({ label, value = "" }) => {
          return (
            <FormControlLabel
              value={value}
              control={<Radio />}
              label={label}
              style={{ width: "fit-content" }}
            />
          );
        })}
      </RadioGroup>
      {description ? (
        <Typography variant="small" style={{ fontSize: "10px" }}>
          {description}
        </Typography>
      ) : null}
    </FormControl>
  );
};

export default RadioGroups;
